import React, { FC } from 'react';

import { InclusionOperator, OlmSelectivityProfile } from '@/api/client';
import Text from '@/presentation/text';
import { groupSelectivityCriteria, renderCriteriaGroupElements } from '@/common/selectivity.methods';
import OlmSelectivityCriterionWithId from './Selectivity.types';
import SSelectivityDetails from './SelectivityDetails.styled';

interface ISelectivityDetailsProps {
  selectivityProfile: OlmSelectivityProfile | undefined;
}

const SelectivityDetails: FC<ISelectivityDetailsProps> = ({ selectivityProfile }) => {
  const inclusionOperation = selectivityProfile?.inclusionOperation;
  const groupedCriteria = selectivityProfile?.criteria
    ? groupSelectivityCriteria(selectivityProfile.criteria as OlmSelectivityCriterionWithId[])
    : null;

  const renderGroups = () => {
    return groupedCriteria?.map((group, index) => (
      <div className="criteria-group mt-10" key={`group-${group[0].primaryKey}`}>
        {renderCriteriaGroupElements(group, index === groupedCriteria.length - 1)}
      </div>
    ));
  };

  const renderDescription = () => {
    if (selectivityProfile?.inclusionOperation === InclusionOperator.Always) {
      return (
        <Text size="xxs" style={{ textAlign: 'center' }} weight="bold">
          ALWAYS add this message.
        </Text>
      );
    }

    let selMessage = '';
    switch (selectivityProfile?.inclusionOperation) {
      case InclusionOperator.UnlessSelectivityOrAnExternalFileMatches:
        selMessage = 'Add this message when a match occurs in an external file OR unless the following is true:';
        break;
      case InclusionOperator.UnlessSelectivityAndAnExternalFileMatches:
        selMessage = 'Add this message when a match occurs in an external file AND unless the following is true:';
        break;
      case InclusionOperator.UnlessSelectivityMatches:
        selMessage = ' Add this message <b>UNLESS</b> the following is true:';
        break;
      case InclusionOperator.WheneverSelectivityOrAnExternalFileMatches:
        selMessage = 'Add this message when a match occurs in an external file OR when the following is true:';
        break;
      case InclusionOperator.WheneverSelectivityAndAnExternalFileMatches:
        selMessage = 'Add this message when a match occurs in an external file AND when the following is true:';
        break;
      case InclusionOperator.WheneverSelectivityMatches:
        selMessage = 'Add this message <b>WHEN</b> the following is true:';
        break;
      case InclusionOperator.WheneverAVantageQueryMatches:
        selMessage = 'Add this message when a match occurs from:';
        break;
      case InclusionOperator.WheneverAVantageQueryAndAnExternalFileMatches:
        selMessage = 'Add this message when a match occurs in an external file AND from:';
        break;
      case InclusionOperator.WheneverAnExternalFileMatches:
        selMessage = 'Add this message when a match occurs in an external file';
        break;
    }

    return (
      <Text size="xxs" style={{ textAlign: 'center' }}>
        <div dangerouslySetInnerHTML={{ __html: selMessage }}></div>
      </Text>
    );
  };

  if (groupedCriteria?.length || selectivityProfile?.inclusionOperation) {
    return (
      <SSelectivityDetails>
        <div className="criteria-container">
          <Text size="xs">Selectivity</Text>
          {renderDescription()}

          {inclusionOperation !== InclusionOperator.Always && groupedCriteria && renderGroups()}
        </div>
      </SSelectivityDetails>
    );
  }

  return null;
};

export default SelectivityDetails;
